import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const announcements = [
  {
    desktop: "Mulesoft to Spring Boot Conversion v2.0 is here! Drive greater migration efficiency and code quality.",
    mobile: "Mulesoft Converter v2.0 is here!"
  },
  {
    desktop: "Seamless Mulesoft to Workato Migration is now available! Modernize your integration stack.",
    mobile: "Mulesoft to Workato is here!"
  }
];

const AnnouncementBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcements.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="w-full bg-[#111527] border-b border-accent/20">
      <div className="container mx-auto">
        <div className="flex items-center justify-between py-3 px-4 sm:px-6 lg:px-8">
          <div className="flex items-center flex-1 overflow-hidden">
            <div className="flex items-center mr-3">
              <span className="bg-background rounded-full p-0.5">
                <span className="inline-flex justify-center items-center w-7 h-7 rounded-full bg-gradient-to-r from-pink-500 to-violet-500">
                  <FaStar className="text-white h-3 w-3" />
                </span>
              </span>
            </div>

            <div className="flex items-center gap-2 flex-wrap min-h-[24px]">
              <span className="bg-background text-white text-xs font-semibold px-2 py-1 rounded-md uppercase tracking-wide">New</span>

              <div className="relative">
                <AnimatePresence mode="wait">
                  <motion.p
                    key={currentIndex}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 }}
                    className="text-white text-sm"
                  >
                    <span className="hidden sm:inline">{announcements[currentIndex].desktop}</span>
                    <span className="inline sm:hidden">{announcements[currentIndex].mobile}</span>
                  </motion.p>
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
